import React, {FC, memo, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import thermometer from "../../image/thermometer.svg"
import temperature from "../../image/temperature.svg"
import humidity from "../../image/humidity.svg"
import {ISensorTemperature} from "../../store/sliceWebsocket";
import {
    SensorTemperatureArticle,
    SensorTemperatureDiv,
    SensorTemperatureImg,
    SensorTemperatureText
} from "./SensorTemperatureStyle";
import {BatteryFull, BatteryHalf, BatteryLow} from "react-bootstrap-icons";
import moment from "moment/moment";


interface SensorTemperatureProps {
    deviceId: string
}

const SensorTemperature: FC<SensorTemperatureProps> = ({deviceId}) => {
    const dispatch = useDispatch<AppDispatch>();
    const iSensorTemperature: ISensorTemperature = useSelector((state: IRootState) => state.websocket.temperatureSensors.filter((sensor: ISensorTemperature) => sensor.deviceId === deviceId)[0])



    const battery = useCallback(() => {
        return <div style={{marginRight: "5px", display: "flex"}}>
            {(!iSensorTemperature?.battery || iSensorTemperature?.battery > 70) && <BatteryFull size={20}/>}
            {iSensorTemperature?.battery <= 70 && iSensorTemperature?.battery > 30 && <BatteryHalf size={20}/>}
            {iSensorTemperature?.battery <= 30 && <BatteryLow size={20}/>}
        </div>
    }, [iSensorTemperature?.battery])


    const isExpired = () => {
        if (iSensorTemperature.date) {
            return (moment().subtract(30, 'minutes')).isAfter(moment(iSensorTemperature.date))
        }
        return false;
    }

    return (
        <SensorTemperatureArticle>
            <SensorTemperatureImg src={thermometer} alt={"Термометр"}/>
            {iSensorTemperature?.location && <SensorTemperatureText>{iSensorTemperature?.location}</SensorTemperatureText>}
            {!iSensorTemperature?.location && <SensorTemperatureText>--</SensorTemperatureText>}
            <SensorTemperatureDiv isExpired={isExpired()}>
                <img src={temperature}/>
                {iSensorTemperature?.temperature && <span>{iSensorTemperature?.temperature} °C</span>}
                {!iSensorTemperature?.temperature && <span>-- °C</span>}
            </SensorTemperatureDiv>
            <SensorTemperatureDiv isExpired={isExpired()}>
                <img src={humidity}/>
                { iSensorTemperature?.humidity && <span>{iSensorTemperature?.humidity} %</span>}
                { !iSensorTemperature?.humidity && <span>-- %</span>}
            </SensorTemperatureDiv>
            <SensorTemperatureDiv>
                {battery()}
                {iSensorTemperature?.battery && <span>{iSensorTemperature?.battery} %</span>}
                {!iSensorTemperature?.battery && <span>-- %</span>}
            </SensorTemperatureDiv>
            {isExpired() && <SensorTemperatureDiv isExpired={isExpired()}>
                {moment(iSensorTemperature.date).format("yyyy-MM-DD HH:mm:ss")}
            </SensorTemperatureDiv>}
        </SensorTemperatureArticle>
    )
}


export default memo(SensorTemperature)

